import * as React from 'react';

export function Loading() {
    return <i className="pi pi-spin pi-spinner" style={{'fontSize': '2em'}} />;
}